
import React from 'react';

const Documentation: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Documentation: The Often Overlooked HIPAA Requirement</h2>
      <p className="mb-4 text-gray-700 leading-relaxed">
        HIPAA compliance isn't just about having the right technology—it's also about documenting your policies, procedures, and actions.
      </p>

      <h3 className="text-xl font-semibold mb-3 mt-6 text-itmgmt-medium-blue">Required Documentation</h3>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Your practice must maintain documentation for:
      </p>
      <ul className="list-disc ml-6 mb-6 text-gray-700 leading-relaxed">
        <li className="mb-2"><strong>Risk Analysis:</strong> Regular, documented assessments of potential risks to ePHI</li>
        <li className="mb-2"><strong>Risk Management Plan:</strong> Documented strategies to address identified risks</li>
        <li className="mb-2"><strong>Security Policies and Procedures:</strong> Formal documentation of security practices</li>
        <li className="mb-2"><strong>Security Incident Procedures:</strong> Documented processes for identifying, responding to, and mitigating security incidents</li>
        <li className="mb-2"><strong>Contingency Plan:</strong> Documented procedures for responding to emergencies or system failures</li>
        <li className="mb-2"><strong>Training Records:</strong> Documentation of security awareness training for all staff</li>
      </ul>

      <div className="bg-itmgmt-light-gray p-6 rounded-lg mb-8">
        <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">HIPAA Compliance Checklist</h3>
        <p className="mb-4 text-gray-700">
          Use this checklist to evaluate your current HIPAA compliance status:
        </p>
        <div className="space-y-3">
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We have conducted and documented a thorough risk analysis</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We encrypt all ePHI at rest and in transit</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We have implemented and documented access controls</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We maintain audit logs and regularly review them</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We have BAAs with all vendors who can access ePHI</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We have a tested disaster recovery plan</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We conduct regular security training for all staff</span>
          </div>
          <div className="flex items-start">
            <div className="w-6 h-6 rounded-md border border-itmgmt-medium-blue flex-shrink-0 mr-2"></div>
            <span className="text-gray-700">We have incident response procedures for potential breaches</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Documentation;
